import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    input: {
      width: '100%',
      margin: theme.spacing(2, 0),
      padding: theme.spacing(0),
    },
    buttons: {
      width: '100%',
      display: 'flex',
      justifyContent: 'end',
      gap: '1.6rem',
      marginTop: '1.5rem',

      '& > button': {
        width: '10rem',
        margin: theme.spacing(0),
      },
    },
  }),
)
